const authorization = (userRole, allowedRoles) => {
  if (allowedRoles === 'all') return true;
  if (allowedRoles && allowedRoles.includes(userRole)) return true;
  return false;
};

export default authorization;
